import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/*
  Generated class for the CurcesDetail page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-CurcesDetail',
    templateUrl: 'CurcesDetail.html'
})
export class CurcesDetailPage {

    constructor(public navCtrl: NavController, public navParams: NavParams) { }
    CurseData: any = {
        Data: [],
        crPicAnlysis: '',
        Image: '',
        crPic1: '',
        crPic2: '',
        crPic3: ''
    };
    ionViewDidLoad() {
        console.log(this.navParams.get("curseData"));
        let curseData: any = this.navParams.get("curseData");
        this.CurseData.Name = curseData.cdValue1_txt;
        this.CurseData.Type = curseData.cdValue2_txt;
        curseData.DetailedForm.forEach((value, index) => {
            switch (value.tODataDetailId) {
                case 87: {
                    this.CurseData.state = value.cddValue_txt;
                    this.CurseData.stateId = value.cddValue;
                    break;
                }
                case 88: {
                    this.CurseData.Image = value.cddValue_txt;
                    break;
                }
                case 10171: {
                    if (value.cddValue_txt) {
                        this.CurseData.crPicAnlysis = value.cddValue_txt;
                    }
                    break;
                }
                case 10172: {
                    if (value.cddValue_txt) {
                        this.CurseData.crPic1 = value.cddValue_txt;
                    }
                    break;
                }
                case 10173: {
                    if (value.cddValue_txt) {
                        this.CurseData.crPic2 = value.cddValue_txt;
                    }
                    break;
                }
                case 10174: {
                    if (value.cddValue_txt) {
                        this.CurseData.crPic3 = value.cddValue_txt;
                    }
                    break;
                }
                case 10176: {
                    if (value.cddValue_txt) {
                        this.CurseData.Registerlink = value.cddValue_txt;
                    }
                    break;
                }
                default: {
                    this.CurseData.Data.push(value);
                    break;
                }
            }
        });
    }
    setTab(index) {
        this.CurseData.ShowTab = index;
    }
    openLink(url) {
        window.open(url, "_system");
    }
}



// WEBPACK FOOTER //
// ./src/pages/academy/CurcesDetail/CurcesDetail.ts